import React from 'react'
import { Waypoint } from 'react-waypoint'
import { Box } from '../Box'

interface InfiniteListProps {
  children: React.ReactNode
  loadMore: () => void
  preloader: React.ReactNode
  threshold?: number
  hasMore: boolean
  isLoading: boolean
}

const InfiniteList = ({ children, loadMore, preloader, threshold, hasMore, isLoading = true }: InfiniteListProps) => (
  <Box>
    {children}
    {isLoading && preloader}
    {hasMore && <Waypoint key={String(isLoading)} onEnter={loadMore} bottomOffset={threshold} />}
  </Box>
)

export { InfiniteList, type InfiniteListProps }
